/**
 * Menu JavaScript singleton module
 */

var Menu = (function($) {

  function initMenu() {

    $('.hamburger').click(function(){
        $('body').toggleClass('has-nav');
    });
  }

  function init() {

    // return early if no corresponding module present
    if (!$('.nav').length) {
      return;
    }

    initMenu();

  }

  return {
    init: init
  };

}(jQuery));

jQuery(document).ready(Menu.init);
